import { SVGProps, Ref, forwardRef, memo } from 'react';

const SvgComponent = (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
  <svg width="10" height="10" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
    <g clipPath="url(#clip0_2047_80252)">
      <path
        d="M5 9.375C7.41625 9.375 9.375 7.41625 9.375 5C9.375 2.58375 7.41625 0.625 5 0.625C2.58375 0.625 0.625 2.58375 0.625 5C0.625 7.41625 2.58375 9.375 5 9.375Z"
        fill="#383838"
        stroke="#383838"
      />
      <circle cx="5" cy="2.8125" r="0.625" fill="white" />
      <rect x="4.375" y="4.375" width="1.25" height="3.4375" rx="0.625" fill="white" />
    </g>
    <defs>
      <clipPath id="clip0_2047_80252">
        <rect width="10" height="10" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

const ForwardRef = forwardRef(SvgComponent);
const InformationIcon = memo(ForwardRef);
export default InformationIcon;
